import { KuposErrorSuccessModal, KuposModalWithButtons } from '../../common';
import React, { Component, useEffect, useState } from 'react';

import ApiUrls from '../../../services/apiUrls';
import CommonService from '../../../services/commonService';
import PropTypes from 'prop-types';
import RutInput from './components/RutInput';

// export default class RechargeWalletKuposPayTransfer extends Component {
//   static propTypes = {
//     t: PropTypes.func,
//     data: PropTypes.object,
//     actions: PropTypes.object,
//     profileData: PropTypes.object,
//   };

//   constructor(props) {
//     super(props);
//     this.state = {
//       selectedView: 'rut',
//       favourites: this.props.profileData.favourites,
//       favAdd: [],
//       favRemove: [],
//       amountError: null,
//     };
//   }

//   componentDidMount() {
//     this.getProfile();
//   }

//   getProfile = () => {
//     this.props.actions.getProfile({ url: ApiUrls.profile() }).then(
//       res => {
//         this.props.actions.setLoginData(res);
//         this.setState({
//           favourites: res.favourites,
//         });
//       },
//       err => {},
//     );
//   };

//   isValid = () => {
//     let errorCount = 0;

//     if (!this.state.rut) {
//       this.setState({
//         rutError: {
//           message: 'VALIDATIONS.VALID_RUT',
//         },
//       });
//       errorCount++;
//     } else if (!CommonService.isRutValid(this.state.rut)) {
//       this.setState({
//         rutError: {
//           message: 'VALIDATIONS.VALID_RUT_VALID',
//         },
//       });
//       errorCount++;
//     }
//     if (errorCount <= 0) {
//       return true;
//     }
//     return false;
//   };

//   getCustomerInfo = () => {
//     this.onBlur(this.state.rut);
//     if (!this.isValid()) {
//       return;
//     }
//     setTimeout(() => {
//       this.props.actions
//         .getCustomerInfo({ url: ApiUrls.customerInfo(this.state.rut) })
//         .then(this.onResponse, err => {});
//     }, 200);
//   };

//   onResponse = result => {
//     console.log(result);
//     if (result && !result.recipient_id) {
//       if (result.status == 404) {
//         this.setState({
//           rutError: {
//             message: result.message,
//           },
//         });
//       } else {
//         this.setState({
//           showSuccessModal: true,
//           responseSuccess: false,
//           modalTitle: this.props.t('HOME.WE_ARE_SORRY'),
//           modalBody1:
//             'Puede que el RUT que ingresaste esté erróneo o no esté registrado en PasajeBus.com',
//           modalBody2: 'Las transferencias de saldo solo son posibles entre cuentas registradas.',
//         });
//       }

//       return;
//     } else if (result && result.recipient_id) {
//       this.setState({
//         recipient: result,
//       });
//     }
//   };

//   onBlur = text => {
//     if (!text) {
//       this.setState({
//         rutError: {
//           message: 'VALIDATIONS.VALID_RUT',
//         },
//       });
//     } else {
//       let rut = CommonService.formatRut(text);
//       this.setState({
//         rut: rut,
//       });
//       if (!CommonService.isRutValid(rut)) {
//         this.setState({
//           rutError: {
//             message: 'VALIDATIONS.VALID_DOCUMENT_NUMBER',
//           },
//         });
//       }
//     }
//   };

//   onSubmitAmount = val => {
//     // if (!this.state.amount) {
//     //   return;
//     // }

//     // this.setState({amount: })

//     console.log('Amount is', this.state.amount);
//     console.log('Wallet Bal is', this.props.profileData.wallet_moneys[0].amount);

//     if (Number(this.state.amount) === 0) {
//       this.setState({
//         amountError: {
//           message: 'TRANSLATIONS.VALID_AMOUNT',
//         },
//       });
//       return;
//     }

//     if (
//       +this.state.amount >
//       +this.props.profileData.wallet_moneys[0].amount
//         .split('.')
//         .join('')
//         .split(' ')[1]
//     ) {
//       this.setState({
//         amountError: {
//           message: 'PROFILE.INSUFFICENT_BALANCE',
//         },
//       });
//       return;
//     }

//     !this.state.amount
//       ? this.setState({
//           amountError: {
//             message: 'VALIDATIONS.TRANSFER_AMOUNT',
//           },
//         })
//       : this.setState({
//           showModal: true,
//           modalTitle: this.props.t('PROFILE.SHARE_BAL_WARNING'),
//           onModalButtonCLick: this.transferAmount,
//           modalButton1Text: this.props.t('PROFILE.YES_SHARE'),
//           modalButton2Text: this.props.t('PROFILE.YES_GO_BACK'),
//           showConfirmAmountBody: true,
//         });
//   };

//   transferAmount = () => {
//     let body = {
//       recipient_id: this.state.recipient.recipient_id,
//       recipient_identity_val: this.state.recipient.recipient_identity_val,
//       recipient_email: this.state.recipient.recipient_email,
//       transfer_amount: this.state.amount,
//     };
//     this.props.actions
//       .transferMoney({
//         url: ApiUrls.transferMoney(),
//         data: body,
//       })
//       .then(
//         result => this.onTransferMoneyResponse(result),
//         err => {},
//       );
//   };

//   onTransferMoneyResponse = result => {
//     if (!result.status) {
//       this.setState({
//         recipient: null,
//         amount: null,
//         rut: null,
//         showModal: false,
//         modalTitle: null,
//         showSuccessModal: true,
//         responseSuccess: true,
//         modalBody1: 'PROFILE.TRANSFER_SUCCESS',
//         modalBody2: 'PROFILE.TRANSFER_SUCCESS_EMAIL',
//       });
//       this.updateProfile();
//     } else {
//       this.setState({
//         showModal: false,
//         modalTitle: null,
//         showSuccessModal: true,
//         responseSuccess: false,
//         modalBody1: 'Tu transacción no pudo ser realizada. Por favor intenta nuevamente.',
//         modalBody2: '¿Necesitas ayuda? ayuda@pasajebus.com +56 9 4915 6683.',
//       });
//     }
//   };

//   updateProfile() {
//     this.setState({ rutError: null });
//     this.props.actions.getProfile({ url: ApiUrls.profile() }).then(
//       res => {
//         if (res && res.error) {
//           return;
//         } else if (res && res.auth_token) {
//           CommonService.storeLoginDetails(res, this.props.actions.setLoginData);
//         }
//       },
//       err => {
//         // if(err.status == 401){
//         //   CommonService.logout();
//         //   this.props.histore.push('/')
//         // }
//       },
//     );
//   }

//   onAmountChange = val => {
//     if (CommonService.onlyNumericValues(val)) {
//       this.setState({ amount: CommonService.onlyNumbers(val), amountError: null });
//     } else {
//       this.setState({
//         amountError: {
//           message: 'VALIDATIONS.TRANSFER_AMOUNT',
//         },
//         amount: CommonService.onlyNumbers(val),
//       });
//     }
//     // this.setState({rechargeAmount:val})
//   };

//   renderRutInput = t => {
//     return (
//       <div className="recharge-steps-outer">
//         <div className="inputs">
//           {!this.state.recipient ? (
//             <div className="rut-input-share-balance">
//               <div className="title bold-text font10">{t('PROFILE.RECIPIENT_RUT')}</div>
//               <KuposInput
//                 placeholder={t('PROFILE.INSERT_RECIPIENT_RUT')}
//                 className="kupos-border font10"
//                 value={this.state.rut}
//                 onBlur={this.onBlur}
//                 onChange={val => this.setState({ rut: val, rutError: null })}
//                 error={this.state.rutError ? true : false}
//                 errorMessage={this.state.rutError ? t(this.state.rutError.message) : ''}
//                 disabled={this.state.recipient}
//               />
//               <div className="button-container font12">
//                 <button
//                   className="kupos-button"
//                   disabled={this.props.data.getCustomerInfoPending}
//                   onClick={this.getCustomerInfo}
//                 >
//                   {this.props.data.getCustomerInfoPending ? (
//                     <div className="loader-cricle"></div>
//                   ) : (
//                     <span>{t('PROFILE.SHARE')}</span>
//                   )}
//                 </button>
//               </div>
//             </div>
//           ) : (
//             <div className="recipient-info">
//               <div className="kupos-card recipient-card font10">
//                 <div className="flex-row change">
//                   <span className="font11 bold-text flex1">{t('PROFILE.RECIPIENT')}</span>
//                   <div className="capsule-menu" onClick={() => this.setState({ recipient: null })}>
//                     {t('PROFILE.CHANGE')}
//                   </div>
//                   <span className="heart-icon selected-contact-recharge-transfer">
//                     <img
//                       onClick={() => this.addRemoveFavourite(this.state.recipient)}
//                       src={
//                         this.isFavourite()
//                           ? '/images/icons/heart.png'
//                           : '/images/icons/heart-empty.png'
//                       }
//                     />
//                   </span>
//                 </div>
//                 <div className="recipient-name">
//                   {this.state.recipient.recipient_name} {this.state.recipient.last_name}
//                 </div>
//                 <div className="recipient-email">{this.state.recipient.recipient_email}</div>
//                 <div className="recipient-rut">
//                   RUT: {this.state.recipient.recipient_identity_val}
//                 </div>
//               </div>
//               <div className="amount-input">
//                 <div className="title bold-text font10">{t('PROFILE.AMOUNT_TO_TRANSFER')}</div>
//                 <KuposInput
//                   placeholder={t('PROFILE.INSERT_TRANSFER_AMOUNT')}
//                   className="kupos-border font10"
//                   value={this.state.amount}
//                   onBlur={() => {}}
//                   onChange={val => this.onAmountChange(val)}
//                   error={this.state.amountError ? true : false}
//                   errorMessage={this.state.amountError ? t(this.state.amountError.message) : ''}
//                 />
//                 <div className="button-container font12">
//                   <button
//                     className="kupos-button"
//                     disabled={this.props.data.getCustomerInfoPending}
//                     onClick={this.onSubmitAmount}
//                   >
//                     {this.props.data.getCustomerInfoPending ? (
//                       <div className="loader-cricle"></div>
//                     ) : (
//                       <span>{t('PROFILE.SHARE')}</span>
//                     )}
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//         <div className="steps">
//           <div className="my-favourites kupos-card">
//             <div className="font11 bold-text">{t('PROFILE.MY_FAV')}</div>
//             <hr />
//             <div className="favourist-list font10">
//               {this.state.favourites &&
//                 this.state.favourites.map((item, key) => (
//                   <div className="favourite-item flex-row" key={key}>
//                     <span onClick={() => this.selectfav(item)} className="name">
//                       {item.name}
//                     </span>
//                     <span onClick={() => this.selectfav(item)} className="rut">
//                       {item.identity_val}
//                     </span>
//                     <span className="heart-icon">
//                       <img
//                         onClick={() => this.addRemoveFavouriteList(item)}
//                         src={
//                           !this.isFavouriteList(item)
//                             ? '/images/icons/heart.png'
//                             : '/images/icons/heart-empty.png'
//                         }
//                       />
//                     </span>
//                   </div>
//                 ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   //favourites ---------

//   isFavourite() {
//     if (this.state.favourites) {
//       return this.state.favourites.find(it => {
//         return this.state.recipient.recipient_id == it.id;
//       });
//     }
//     return null;
//   }

//   addRemoveFavourite(cust) {
//     let isFav = this.state.favourites.find(it => {
//       return it.identity_val == cust.recipient_identity_val;
//     });
//     let isFavList = this.state.favRemove.find(it => {
//       return it == cust.recipient_id;
//     });
//     if (isFavList) {
//       let favRemove = this.state.favRemove.filter(it => {
//         return it != cust.recipient_id;
//       });
//       this.setState({
//         favRemove: favRemove,
//       });
//     }
//     let isFavListAdd = this.state.favAdd.find(it => {
//       return it == cust.recipient_id;
//     });
//     if (isFavListAdd) {
//       let favAdd = this.state.favAdd.filter(it => {
//         return it != cust.recipient_id;
//       });
//       this.setState({
//         favAdd: favAdd,
//       });
//     }
//     if (!isFav) {
//       if (this.state.favourites.length > 5) {
//         this.refs.toast.show('Máximo 5 favoritos permitidos por cuenta.');
//         return;
//       }
//       let favAdd = CommonService.copyObject(this.state.favAdd);
//       favAdd.push(cust.recipient_id);
//       let favourites = CommonService.copyObject(this.state.favourites);
//       favourites.push({
//         id: cust.recipient_id,
//         name: cust.recipient_name,
//         email: cust.recipient_email,
//         identity_val: cust.recipient_identity_val,
//       });
//       this.setState({
//         favourites: favourites,
//         favAdd: favAdd,
//       });
//     } else {
//       let favRemove = CommonService.copyObject(this.state.favRemove);
//       favRemove.push(cust.recipient_id);
//       let favourites = this.state.favourites.filter(it => {
//         return it.identity_val != cust.recipient_identity_val;
//       });
//       this.setState({
//         favourites: favourites,
//         favRemove: favRemove,
//       });
//     }
//   }

//   addRemoveFavouriteList(cust) {
//     if (this.isFavouriteList(cust)) {
//       // this.state.favAdd.push(cust.id);
//       let favRemove = this.state.favRemove.filter(it => {
//         return it != cust.id;
//       });
//       this.setState({
//         favRemove: favRemove,
//       });
//     } else {
//       let favRemove = CommonService.copyObject(this.state.favRemove);
//       favRemove.push(cust.id);

//       this.setState({
//         favRemove: favRemove,
//       });
//     }
//   }

//   isFavouriteList(fav) {
//     if (this.state.favourites) {
//       return this.state.favRemove.find(it => {
//         return fav.id == it;
//       });
//     }
//     return null;
//   }

//   selectfav(fav) {
//     let customerInfo = {};
//     customerInfo.recipient_id = fav.id;
//     customerInfo.recipient_name = fav.name;
//     customerInfo.recipient_email = fav.email;
//     customerInfo.recipient_identity_val = fav.identity_val;
//     this.setState({
//       recipient: customerInfo,
//       rut: fav.identity_val,
//       rutError: null,
//     });
//     setTimeout(() => {
//       this.setState({
//         rutError: null,
//       });
//     }, 200);
//   }

//   componentWillUnmount() {
//     let body = {
//       add: this.state.favAdd,
//       remove: this.state.favRemove,
//     };
//     this.props.actions.updateFavourites({ url: ApiUrls.favourites(), data: body });
//   }

//   render() {
//     const { t } = this.props;
//     return (
//       <div
//         id="sub-body-my-account"
//         className="my-account-recharge-wallet-kupospay-recharge transfer-money"
//       >
//         <div className="my-account-recharge-wallet-kupospay-recharge-inner">
//           <div className="white-triangle share-balance"></div>

//           {this.state.recipient ? (
//             <div className="pointer" onClick={() => this.setState({ recipient: null, rut: null })}>
//               <img style={{ height: 17, width: 'auto' }} src="/images/back_arrow_bip.png" />
//             </div>
//           ) : null}
//           <div className="my-account-title center-text">
//             <div className="sub-section-account-general-title font13">
//               {t('PROFILE.SHARE_MONEY_HEADING.NORMAL')}{' '}
//               <span className="bold-text">{t('PROFILE.SHARE_MONEY_HEADING.BOLD')}</span>
//             </div>
//             <div className="sub-section-account-general-description font11">
//               <span>{t('PROFILE.SHARE_MONEY_DESCRIPTION')}</span>
//             </div>
//           </div>
//           <div className="recharge-transfer-body">
//             {this.state.selectedView == 'rut' ? this.renderRutInput(t) : null}
//           </div>
//         </div>
//         <KuposErrorSuccessModal
//           showModal={this.state.showSuccessModal}
//           title={this.state.modalTitle}
//           success={this.state.responseSuccess}
//           subTitle={this.state.modalBody1}
//           t={t}
//           bodyText={this.state.modalBody2}
//           onButtonClick={() => this.setState({ showSuccessModal: false })}
//         />
//         <KuposModalWithButtons
//           showModal={this.state.showModal}
//           onHide={() => this.setState({ showModal: false })}
//           title={this.state.modalTitle}
//           showButton1={true}
//           showButton2={true}
//           buttonText1={
//             this.props.data.transferMoneyPending ? (
//               <div className="loader-cricle"></div>
//             ) : (
//               this.state.modalButton1Text
//             )
//           }
//           buttonText2={this.state.modalButton2Text}
//           onButtonClick1={this.state.onModalButtonCLick}
//           onButtonClick2={() => this.setState({ showModal: false })}
//         >
//           {this.state.showConfirmAmountBody ? (
//             <div className="transfer-money-modal-body font10">
//               <div className="flex-row space-between">
//                 <div>{t('PROFILE.PREV_BAL')}: </div>
//                 <div>CLP {this.props.profileData.wallet_moneys[0].amount.split(' ').join('')}</div>
//               </div>
//               <div className="flex-row space-between">
//                 <div>{t('PROFILE.TRANSFER_AMOUNT')}: </div>
//                 <div>CLP {CommonService.currency(this.state.amount).split(',')[0]}</div>
//               </div>
//               <hr />
//               <div className="flex-row space-between bold-text">
//                 <div>{t('PROFILE.REMAINING_BAL')}: </div>
//                 <div>
//                   CLP{' '}
//                   {
//                     CommonService.currency(
//                       +this.props.profileData.wallet_moneys[0].amount
//                         .split(' ')[1]
//                         .replace('.', '') - +this.state.amount,
//                     ).split(',')[0]
//                   }
//                 </div>
//               </div>
//             </div>
//           ) : null}

//           {this.state.showTransferSuccessBody ? (
//             <div className="transfer-money-modal-body font10">
//               ¡Listo! El saldo ha sido enviado a la cuenta seleccionada.
//               <div></div>
//               Te hemos enviado un mensaje de correo electrónico con los detalles de tu transacción.
//             </div>
//           ) : null}

//           {this.state.showTransferFailBody ? (
//             <div className="transfer-money-modal-body font10">
//               Tu transacción no pudo ser realizada. Por favor intenta nuevamente.
//               <div></div>
//               ¿Necesitas ayuda? ayuda@pasajebus.com +56 9 4915 6683.
//             </div>
//           ) : null}
//         </KuposModalWithButtons>
//       </div>
//     );
//   }
// }

function RechargeWalletKuposPayTransfer(props) {
  let refs = null;
  const [selectedView, setSelectedView] = useState('rut');
  const [favourites, setFavourites] = useState(props.profileData.favourites);
  const [favAdd, setFavAdd] = useState([]);
  const [favRemove, setFavRemove] = useState([]);
  const [amountError, setAmountError] = useState(null);
  const [recipient, setRecipient] = useState(null);

  const [amount, setAmount] = useState(null);
  const [rut, setRut] = useState(null);
  const [showSuccessModal, setShowSuccessModal] = useState(null);
  const [responseSuccess, setResponseSuccess] = useState(null);
  const [rutError, setRutError] = useState(null);
  const [modalBody1, setModalBody1] = useState(null);
  const [modalBody2, setModalBody2] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [showModal, setShowModal] = useState(null);
  const [onModalButtonClick, setOnModalButtonClick] = useState(null);
  const [modalButton1Text, setModalButton1Text] = useState(null);
  const [modalButton2Text, setModalButton2Text] = useState(null);
  const [showConfirmAmountBody, setShowConfirmAmountBody] = useState(null);
  const [showTransferSuccessBody, setShowTransferSuccessBody] = useState(null);
  const [showTransferFailBody, setShowTransferFailBody] = useState(null);

  const getProfile = () => {
    props.actions.getProfile({ url: ApiUrls.profile() }).then(
      res => {
        props.actions.setLoginData(res);

        setFavourites(res.favourites);
      },
      err => {},
    );
  };

  useEffect(() => {
    getProfile();

    return () => {
      let body = {
        add: favAdd,
        remove: favRemove,
      };
      props.actions.updateFavourites({ url: ApiUrls.favourites(), data: body });
    };
  }, []);

  const isValid = () => {
    let errorCount = 0;

    if (!rut) {
      // this.setState({
      //   rutError: {
      //     message: 'VALIDATIONS.VALID_RUT',
      //   },
      // });
      setRutError({
        message: 'VALIDATIONS.VALID_RUT',
      });
      errorCount++;
    } else if (!CommonService.isRutValid(rut)) {
      // this.setState({
      //   rutError: {
      //     message: 'VALIDATIONS.VALID_RUT_VALID',
      //   },
      // });
      setRutError({
        message: 'VALIDATIONS.VALID_RUT_VALID',
      });
      errorCount++;
    }
    if (errorCount <= 0) {
      return true;
    }
    return false;
  };

  const getCustomerInfo = () => {
    onBlur(rut);
    if (!isValid()) {
      return;
    }
    setTimeout(() => {
      props.actions.getCustomerInfo({ url: ApiUrls.customerInfo(rut) }).then(onResponse, err => {});
    }, 200);
  };

  const onResponse = result => {
    console.log(result);
    if (result && !result.recipient_id) {
      if (result.status == 404) {
        // this.setState({
        //   rutError: {
        //     message: result.message,
        //   },
        // });
        setRutError({
          message: result.message,
        });
      } else {
        // this.setState({
        //   showSuccessModal: true,
        //   responseSuccess: false,
        //   modalTitle: this.props.t('HOME.WE_ARE_SORRY'),
        //   modalBody1:
        //     'Puede que el RUT que ingresaste esté erróneo o no esté registrado en PasajeBus.com',
        //   modalBody2: 'Las transferencias de saldo solo son posibles entre cuentas registradas.',
        // });
        setShowSuccessModal(true);
        setResponseSuccess(false);
        setModalTitle(props.t('HOME.WE_ARE_SORRY'));
        setModalBody1(
          'Puede que el RUT que ingresaste esté erróneo o no esté registrado en PasajeBus.com',
        );
        setModalBody2('Las transferencias de saldo solo son posibles entre cuentas registradas.');
      }

      return;
    } else if (result && result.recipient_id) {
      // this.setState({
      //   recipient: result,
      // });
      setRecipient(result);
    }
  };
  const onBlur = text => {
    if (!text) {
      // this.setState({
      //   rutError: {
      //     message: 'VALIDATIONS.VALID_RUT',
      //   },
      // });
      setRutError({
        message: 'VALIDATIONS.VALID_RUT',
      });
    } else {
      let rut = CommonService.formatRut(text);
      // this.setState({
      //   rut: rut,
      // });
      setRut(rut);
      if (!CommonService.isRutValid(rut)) {
        // this.setState({
        //   rutError: {
        //     message: 'VALIDATIONS.VALID_DOCUMENT_NUMBER',
        //   },
        // });
        setRutError({
          message: 'VALIDATIONS.VALID_DOCUMENT_NUMBER',
        });
      }
    }
  };

  const onSubmitAmount = val => {
    // if (!this.state.amount) {
    //   return;
    // }

    // this.setState({amount: })

    console.log('Amount is', amount);
    console.log('Wallet Bal is', props.profileData.wallet_moneys[0].amount);

    if (Number(amount) === 0) {
      // this.setState({
      //   amountError: {
      //     message: 'TRANSLATIONS.VALID_AMOUNT',
      //   },
      // });
      setAmountError({
        message: 'TRANSLATIONS.VALID_AMOUNT',
      });
      return;
    }

    if (
      +amount >
      +props.profileData.wallet_moneys[0].amount
        .split('.')
        .join('')
        .split(' ')[1]
    ) {
      // this.setState({
      //   amountError: {
      //     message: 'PROFILE.INSUFFICENT_BALANCE',
      //   },
      // });
      setAmountError({
        message: 'PROFILE.INSUFFICENT_BALANCE',
      });
      return;
    }

    if (!amount) {
      setAmountError({
        message: 'VALIDATIONS.TRANSFER_AMOUNT',
      });
    } else {
      setShowModal(true);
      setModalTitle(props.t('PROFILE.SHARE_BAL_WARNING'));
      // setOnModalButtonClick(transferAmount);
      setModalButton1Text(props.t('PROFILE.YES_SHARE'));
      setModalButton2Text(props.t('PROFILE.YES_GO_BACK'));
      setShowConfirmAmountBody(true);
    }

    // !amount
    //   ? setAmountError({
    //       message: 'VALIDATIONS.TRANSFER_AMOUNT',
    //     })
    //   : this.setState({
    //       showModal: true,
    //       modalTitle: this.props.t('PROFILE.SHARE_BAL_WARNING'),
    //       onModalButtonCLick: this.transferAmount,
    //       modalButton1Text: this.props.t('PROFILE.YES_SHARE'),
    //       modalButton2Text: this.props.t('PROFILE.YES_GO_BACK'),
    //       showConfirmAmountBody: true,
    //     });
  };

  const transferAmount = () => {
    let body = {
      recipient_id: recipient.recipient_id,
      recipient_identity_val: recipient.recipient_identity_val,
      recipient_email: recipient.recipient_email,
      transfer_amount: amount,
    };
    props.actions
      .transferMoney({
        url: ApiUrls.transferMoney(),
        data: body,
      })
      .then(
        result => onTransferMoneyResponse(result),
        err => {},
      );

    setRut('');
  };

  const updateProfile = () => {
    // this.setState({ rutError: null });
    setRutError(null);
    props.actions.getProfile({ url: ApiUrls.profile() }).then(
      res => {
        if (res && res.error) {
          return;
        } else if (res && res.auth_token) {
          CommonService.storeLoginDetails(res, props.actions.setLoginData);
        }
      },
      err => {},
    );
  };

  const onTransferMoneyResponse = result => {
    if (!result.status) {
      // this.setState({
      //   recipient: null,
      //   amount: null,
      //   rut: null,
      //   showModal: false,
      //   modalTitle: null,
      //   showSuccessModal: true,
      //   responseSuccess: true,
      //   modalBody1: 'PROFILE.TRANSFER_SUCCESS',
      //   modalBody2: 'PROFILE.TRANSFER_SUCCESS_EMAIL',
      // });
      setRecipient(null);
      setAmount(null);
      setRut(null);
      setShowModal(false);
      setModalTitle(null);
      setShowSuccessModal(true);
      setResponseSuccess(true);
      setModalBody1('PROFILE.TRANSFER_SUCCESS');
      setModalBody2('PROFILE.TRANSFER_SUCCESS_EMAIL');
      updateProfile();
    } else {
      // this.setState({
      //   showModal: false,
      //   modalTitle: null,
      //   showSuccessModal: true,
      //   responseSuccess: false,
      //   modalBody1: 'Tu transacción no pudo ser realizada. Por favor intenta nuevamente.',
      //   modalBody2: '¿Necesitas ayuda? ayuda@pasajebus.com +56 9 4915 6683.',
      // });
      setShowModal(false);
      setModalTitle(null);
      setShowSuccessModal(true);
      setResponseSuccess(false);
      setModalBody1('Tu transacción no pudo ser realizada. Por favor intenta nuevamente.');
      setModalBody2('¿Necesitas ayuda? ayuda@pasajebus.com +56 9 4915 6683.');
    }
  };

  const onAmountChange = val => {
    if (CommonService.onlyNumericValues(val)) {
      // this.setState({ amount: CommonService.onlyNumbers(val), amountError: null });
      setAmount(CommonService.onlyNumbers(val));
      setAmountError(null);
    } else {
      // this.setState({
      //   amountError: {
      //     message: 'VALIDATIONS.TRANSFER_AMOUNT',
      //   },
      //   amount: CommonService.onlyNumbers(val),
      // });
      setAmountError({
        message: 'VALIDATIONS.TRANSFER_AMOUNT',
      });
      setAmount(CommonService.onlyNumbers(val));
    }
    // this.setState({rechargeAmount:val})
  };

  const isFavourite = () => {
    if (favourites) {
      return favourites.find(it => {
        return recipient.recipient_id == it.id;
      });
    }
    return null;
  };

  const addRemoveFavourite = cust => {
    let isFav = favourites.find(it => {
      return it.identity_val == cust.recipient_identity_val;
    });
    let isFavList = favRemove.find(it => {
      return it == cust.recipient_id;
    });
    if (isFavList) {
      let favRemoveTemp = favRemove.filter(it => {
        return it != cust.recipient_id;
      });
      // this.setState({
      //   favRemove: favRemove,
      // });
      setFavRemove(favRemoveTemp);
    }
    let isFavListAdd = favAdd.find(it => {
      return it == cust.recipient_id;
    });
    if (isFavListAdd) {
      let favAddTemp = favAdd.filter(it => {
        return it != cust.recipient_id;
      });
      // this.setState({
      //   favAdd: favAdd,
      // });
      setFavAdd(favAddTemp);
    }
    if (!isFav) {
      if (favourites.length > 5) {
        refs.toast.show('Máximo 5 favoritos permitidos por cuenta.');
        return;
      }
      let favAddTemp = CommonService.copyObject(favAdd);
      favAddTemp.push(cust.recipient_id);
      let favouritesTemp = CommonService.copyObject(favourites);
      favouritesTemp.push({
        id: cust.recipient_id,
        name: cust.recipient_name,
        email: cust.recipient_email,
        identity_val: cust.recipient_identity_val,
      });
      // this.setState({
      //   favourites: favourites,
      //   favAdd: favAdd,
      // });
      setFavourites(favouritesTemp);
      setFavAdd(favAddTemp);
    } else {
      let favRemoveTemp = CommonService.copyObject(favRemove);
      favRemoveTemp.push(cust.recipient_id);
      let favouritesTemp = favourites.filter(it => {
        return it.identity_val != cust.recipient_identity_val;
      });
      // this.setState({
      //   favourites: favourites,
      //   favRemove: favRemove,
      // });
      setFavourites(favouritesTemp);
      setFavRemove(favRemoveTemp);
    }
  };

  const addRemoveFavouriteList = cust => {
    if (isFavouriteList(cust)) {
      // this.state.favAdd.push(cust.id);
      let favRemoveTemp = favRemove.filter(it => {
        return it != cust.id;
      });
      // this.setState({
      //   favRemove: favRemove,
      // });
      setFavRemove(favRemoveTemp);
    } else {
      let favRemoveTemp = CommonService.copyObject(favRemove);
      favRemoveTemp.push(cust.id);

      // this.setState({
      //   favRemove: favRemove,
      // });
      setFavRemove(favRemoveTemp);
    }
  };

  const isFavouriteList = fav => {
    if (favourites) {
      return favRemove.find(it => {
        return fav.id == it;
      });
    }
    return null;
  };

  const selectfav = fav => {
    let customerInfo = {};
    customerInfo.recipient_id = fav.id;
    customerInfo.recipient_name = fav.name;
    customerInfo.recipient_email = fav.email;
    customerInfo.recipient_identity_val = fav.identity_val;
    // this.setState({
    //   recipient: customerInfo,
    //   rut: fav.identity_val,
    //   rutError: null,
    // });
    setRecipient(customerInfo);
    setRut(fav.identity_val);
    setRutError(null);
    setTimeout(() => {
      // this.setState({
      //   rutError: null,
      // });
      setRutError(null);
    }, 200);
  };

  const { t } = props;
  return (
    <div
      id="sub-body-my-account"
      className="my-account-recharge-wallet-kupospay-recharge transfer-money"
    >
      <div className="my-account-recharge-wallet-kupospay-recharge-inner">
        <div className="white-triangle share-balance"></div>

        {recipient ? (
          <div
            className="pointer"
            onClick={() => {
              // this.setState({ recipient: null, rut: null });
              setRecipient(null);
              setRut(null);
            }}
          >
            <img style={{ height: 17, width: 'auto' }} src="/images/back_arrow_bip.png" />
          </div>
        ) : null}
        <div className="my-account-title center-text">
          <div className="sub-section-account-general-title font13">
            {t('PROFILE.SHARE_MONEY_HEADING.NORMAL')}{' '}
            <span className="bold-text">{t('PROFILE.SHARE_MONEY_HEADING.BOLD')}</span>
          </div>
          <div className="sub-section-account-general-description font11">
            <span>{t('PROFILE.SHARE_MONEY_DESCRIPTION')}</span>
          </div>
        </div>
        <div className="recharge-transfer-body">
          {selectedView == 'rut' ? (
            <RutInput
              t={t}
              setRut={setRut}
              rutError={rutError}
              setRutError={setRutError}
              recipient={recipient}
              amountError={amountError}
              rut={rut}
              data={props.data}
              selectfav={selectfav}
              onSubmitAmount={onSubmitAmount}
              favourites={favourites}
              onBlur={onBlur}
              amount={amount}
              getCustomerInfo={getCustomerInfo}
              setRecipient={setRecipient}
              addRemoveFavourite={addRemoveFavourite}
              isFavourite={isFavourite}
              onAmountChange={onAmountChange}
              isFavouriteList={isFavouriteList}
              addRemoveFavouriteList={addRemoveFavouriteList}
            />
          ) : null}
        </div>
      </div>
      <KuposErrorSuccessModal
        showModal={showSuccessModal}
        title={modalTitle}
        success={responseSuccess}
        subTitle={modalBody1}
        t={t}
        bodyText={modalBody2}
        onButtonClick={() => setShowSuccessModal(false)}
      />
      <KuposModalWithButtons
        showModal={showModal}
        onHide={() => setShowModal(false)}
        title={modalTitle}
        showButton1={true}
        showButton2={true}
        buttonText1={
          props.data.transferMoneyPending ? <div className="loader-cricle"></div> : modalButton1Text
        }
        buttonText2={modalButton2Text}
        onButtonClick1={transferAmount}
        onButtonClick2={() => setShowModal(false)}
      >
        {console.log(
          'props.data.transferMoneyPending NOW',
          Number(
            props.profileData.wallet_moneys[0].amount
              .replace(' ', '')
              .replace('$', '')
              .replace('.', ''),
          ),
        )}
        {console.log(
          'props.data.transferMoneyPending 3',
          Number(props.profileData.wallet_moneys[0].amount.split(' ')[1].replace('.', '')) * 1000 -
            (1000 * 1000) / 1000,
        )}
        {showConfirmAmountBody ? (
          <div className="transfer-money-modal-body font10">
            <div className="flex-row space-between">
              <div>{t('PROFILE.PREV_BAL')}: </div>
              <div>CLP {props.profileData.wallet_moneys[0].amount.split(' ').join('')}</div>
            </div>
            <div className="flex-row space-between">
              <div>{t('PROFILE.TRANSFER_AMOUNT')}: </div>
              <div>CLP {CommonService.currency(amount).split(',')[0]}</div>
            </div>
            <hr />
            <div className="flex-row space-between bold-text">
              <div>{t('PROFILE.REMAINING_BAL')}: </div>
              <div>
                CLP{' '}
                {props.profileData.wallet_moneys[0] &&
                  amount &&
                  CommonService.currency(
                    +Number(
                      props.profileData.wallet_moneys[0].amount
                        .replace(' ', '')
                        .replace('$', '')
                        .replace('.', ''),
                    ) -
                      amount
                        .replace(' ', '')
                        .replace('$', '')
                        .replace('.', ''),
                  ).split(',')[0]

                // CommonService.currency(
                //   +props.profileData.wallet_moneys[0].amount.split(' ')[1].replace('.', '') -
                //     +amount,
                // ).split(',')[0]
                }
              </div>
            </div>
          </div>
        ) : null}

        {showTransferSuccessBody ? (
          <div className="transfer-money-modal-body font10">
            ¡Listo! El saldo ha sido enviado a la cuenta seleccionada.
            <div></div>
            Te hemos enviado un mensaje de correo electrónico con los detalles de tu transacción.
          </div>
        ) : null}

        {showTransferFailBody ? (
          <div className="transfer-money-modal-body font10">
            Tu transacción no pudo ser realizada. Por favor intenta nuevamente.
            <div></div>
            ¿Necesitas ayuda? ayuda@pasajebus.com +56 9 4915 6683.
          </div>
        ) : null}
      </KuposModalWithButtons>
    </div>
  );
}

export default RechargeWalletKuposPayTransfer;



// WEBPACK FOOTER //
// ./src/features/my-account/RechargeWalletKuposPayTransfer/RechargeWalletKuposPayTransfer.js